import { Injectable, REQUEST_CONTEXT, inject } from '@angular/core';

import { ClientConfigProductName, ClientConfigService, WINDOW } from '@frontend/vanilla/core';
import { VnRequestContext } from '@frontend/vanilla/ssr';

@Injectable({
    providedIn: 'root',
})
export class HostAppClientConfigService {
    private requestContext = inject<VnRequestContext>(REQUEST_CONTEXT);
    private clientConfigService = inject(ClientConfigService);
    private alreadyLoaded: ClientConfigProductName[] = [];
    readonly #window = inject(WINDOW);

    constructor() {
        const endpoints = this.requestContext?.endPoints || this.#window['_endpoints'];
        if (Array.isArray(endpoints)) {
            endpoints.forEach((endpoint) => {
                if (Array.isArray(endpoint)) {
                    const [key, _] = endpoint;
                    this.alreadyLoaded.push(key);
                }
            });
        }
    }

    async tryLoad(product: ClientConfigProductName) {
        if (this.alreadyLoaded.includes(product)) {
            return;
        }

        await this.clientConfigService.loadProduct(product);
        this.alreadyLoaded.push(product);
    }
}
